const root = 'importList-importListProduct-imageGallery'

export const TestId = {
  imageGallery: root,
  tile: `${root}-tile`,
  tileImage: `${root}-tile-image`,
  tileEnlargeButton: `${root}-tile-enlargeButton`,
  tileMoreButton: `${root}-tile-moreButton`,
  tileMoreButtonButton: `${root}-tile-moreButton-button`,
  tileCheckbox: `${root}-tile-checkbox`,
  zoom: `${root}-zoom`,
  setMainImage: `${root}-setMainImage`,
}
